import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

import { useRoute, useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { IDinhMucCoDinhNewResponseBase, IVatTuDinhMucCoDinh, IVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { swalErrNotification } from '@/core/helpers/utils';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import { AddVatTuItemsFor } from '@/core/enums/addVatTuItemsFor.enum';
import { DinhMucCoDinhService } from '@/core/services/DinhMucCoDinh.service';
import AddVatTuItemV2 from '@/components/add-vat-tu-items-v2/AddVatTuItemV2.vue';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DinhMucCoDinhVatTuTable
  from '@/components/dinh-muc-co-dinh-section/dinh-muc-co-dinh-table/DinhMucCoDinhVatTuTable.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const { formatDisplayingDate } = useDateTime();

const { params: { id: idDinhMuc } } = useRoute();

const { back } = useRouter();

const dinhMucDetail = ref<IDinhMucCoDinhNewResponseBase | null>(null);

const { startLoading, endLoading } = useLoading();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const vatTuDinhMucTransform = computed<IVatTuResponseBase[]>(() => {
  if (!dinhMucDetail.value) return [];

  return dinhMucDetail.value?.vat_tu.map((vatTuDinhMuc: IVatTuDinhMucCoDinh) => ({
    ...vatTuDinhMuc,
    so_luong: vatTuDinhMuc.pivot.so_luong,
  }));
});

const isAddVatTuModalDisplay = ref(false);

const fetchData = async () => {
  try {
    await startLoading();

    const { data: { data } } = await DinhMucCoDinhService.get(+idDinhMuc);

    dinhMucDetail.value = data;

    await endLoading();
  } catch (error) {
    await endLoading();

    await swalErrNotification(error, 'Có lỗi xảy ra');
  }
}

onMounted(async () => {
  setCurrentPageTitle('Định mức cố định');

  await fetchData();
});

const addVatTu = async ({ selectingVatTuItems }: { selectingVatTuItems: IVatTuResponseBase[] }) => {
  await DinhMucCoDinhService.attachVatTuItems({
    id_dinh_muc: dinhMucDetail.value?.id ?? 0,
    vat_tu_items: selectingVatTuItems,
  });

  await fetchData();
}

const confirmAddVatTuItems = ({ selectingVatTuItems }: { selectingVatTuItems: IVatTuResponseBase[] }) => {
  isAddVatTuModalDisplay.value = false;

  addVatTu({
    selectingVatTuItems: [
      ...selectingVatTuItems,
      ...vatTuDinhMucTransform.value,
    ],
  });
}

const removingVatTuItem = ref<null | IVatTuResponseBase>(null);

const confirmRemoveVatTu = ({ id_vat_tu }) => {
  removingVatTuItem.value = vatTuDinhMucTransform.value.find(({ id }) => id === id_vat_tu) ?? null;
}

const removeVatTu = async ({ id_vat_tu }: { id_vat_tu: number }) => {
  const removeIndex = vatTuDinhMucTransform.value.findIndex(({ id }) => id === id_vat_tu);

  const selectingVatTuItems = vatTuDinhMucTransform.value.filter((_vatTu, index) => removeIndex !== index);

  await addVatTu({
    selectingVatTuItems,
  });

  removingVatTuItem.value = null;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (dinhMucDetail.value)
      ? (_openBlock(), _createBlock(AddVatTuItemV2, {
          key: 0,
          "is-modal-open": isAddVatTuModalDisplay.value,
          "use-for": _unref(AddVatTuItemsFor).ADD_VAT_TU_DINH_MUC_CO_DINH,
          "vat-tu-selected": vatTuDinhMucTransform.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddVatTuModalDisplay.value = false)),
          onAdded: confirmAddVatTuItems
        }, null, 8, ["is-modal-open", "use-for", "vat-tu-selected"]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmationDialog, {
      title: "Xoá?",
      "is-display": !!removingVatTuItem.value,
      width: "30%",
      onOnConfirmButtonClick: _cache[1] || (_cache[1] = ($event: any) => (removeVatTu({
      id_vat_tu: removingVatTuItem.value?.id ?? 0,
    }))),
      onOnCloseButtonClick: _cache[2] || (_cache[2] = ($event: any) => (removingVatTuItem.value = null)),
      onOnCloseIconClick: _cache[3] || (_cache[3] = ($event: any) => (removingVatTuItem.value = null))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_1, _toDisplayString(removingVatTuItem.value?.ten_vat_tu), 1)
      ]),
      _: 1
    }, 8, ["is-display"]),
    _createVNode(PageRowLayout, null, _createSlots({
      "page-row-header": _withCtx(() => [
        _createTextVNode("Chi tiết")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(ButtonCustom, {
          "button-type": _unref(ButtonsType).BACK,
          onClick: _unref(back)
        }, null, 8, ["button-type", "onClick"])
      ]),
      _: 2
    }, [
      (dinhMucDetail.value)
        ? {
            name: "page-row-content",
            fn: _withCtx(() => [
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" ID: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, null, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(dinhMucDetail.value.id), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ngày b/hành: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(dinhMucDetail.value.ngay_ban_hanh)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ngày hết hạn: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(dinhMucDetail.value.ngay_het_han)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ngày tạo: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(dinhMucDetail.value.created_at ? new Date(dinhMucDetail.value.created_at) : null)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Ngày sửa: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(new Date(dinhMucDetail.value.updated_at))), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" D/m toa xe: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_RouterLink, {
                        to: {
              name: 'chi-tiet-danh-muc-toa-xe',
              params: {
                id: dinhMucDetail.value.id_danh_muc_toa_xe,
              },
            },
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(dinhMucDetail.value.danh_muc_toa_xe.ten_danh_muc), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Cấp sửa chữa: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_RouterLink, {
                        to: {
            name: 'chi-tiet-cap-sua-chua',
            params: {
              id: dinhMucDetail.value.id_cap_sc,
            },
          },
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(dinhMucDetail.value.cap_sua_chua.ten_cap_sc), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(LabelCustom, { "is-text-muted": true }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Mô tả: ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, { cols: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: dinhMucDetail.value.cap_sua_chua.mo_ta,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dinhMucDetail.value.cap_sua_chua.mo_ta) = $event)),
                        disabled: "",
                        type: "textarea",
                        rows: 2
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (dinhMucDetail.value)
      ? (_openBlock(), _createBlock(PageRowLayout, { key: 1 }, {
          "page-row-header": _withCtx(() => [
            _createTextVNode("Vật tư")
          ]),
          "page-row-action-button": _withCtx(() => [
            _createVNode(ButtonCustom, {
              "button-type": _unref(ButtonsType).EDIT,
              "color-type": _unref(ButtonTypeColors).SUCCESS,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (isAddVatTuModalDisplay.value = true))
            }, {
              "button-label": _withCtx(() => [
                _createTextVNode("Chỉnh sửa")
              ]),
              _: 1
            }, 8, ["button-type", "color-type"])
          ]),
          "page-row-content": _withCtx(() => [
            _createVNode(DinhMucCoDinhVatTuTable, {
              items: dinhMucDetail.value.vat_tu,
              "show-delete-button": true,
              onRemove: confirmRemoveVatTu
            }, null, 8, ["items"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})